import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./TestimonialSection.css";
import Badge from "../ServiceSection/Badge";



const reviews = [
  {
    name: "Michael Johnson",
    service: "Residential Roof Repair",
    location: "Homeowner",
    text: "I had a roof leak after a heavy storm, and Ultimates Roofing responded quickly. They identified the issue fast and repaired it the same day. I truly appreciate their professionalism and honesty.",
  },
  {
    name: "Sarah Williams",
    service: "Full Roof Replacement",
    location: "Homeowner",
    text: "The experience was seamless from start to finish. The crew was punctual, respectful, and cleaned up everything perfectly. My new roof looks amazing, and I feel much safer now.",
  },
  {
    name: "David Thompson",
    service: "Commercial Installation",
    location: "Business Owner",
    text: "As a business owner, I needed a reliable company for our new commercial roof installation. They exceeded expectations, finishing on time and within budget. Quality work is outstanding.",
  },
  {
    name: "Lisa Anderson",
    service: "Detailed Roof Inspection",
    location: "Homeowner",
    text: "I booked an inspection before selling my home. They gave me a detailed report and honest advice without pushing unnecessary services. Very professional and trustworthy team.",
  },
  {
    name: "Robert Martinez",
    service: "Commercial Replacement",
    location: "Business Owner",
    text: "Our building needed a full replacement, and they handled everything smoothly with minimal disruption to our operations. Excellent communication and top-quality results.",
  },
  {
    name: "Jennifer Clark",
    service: "Residential Installation",
    location: "New Homeowner",
    text: "Hired them for our new build. The team was skilled, friendly, and very detail-oriented. The roof looks perfect and adds great value to our home. Fantastic job!",
  },
];

const stats = [
  { value: "4.9",  label: "Google Rating", icon: "bi-star-fill" },
  { value: "500+", label: "Projects Done",  icon: "bi-house-check-fill" },
  { value: "100%", label: "Satisfaction",   icon: "bi-shield-fill-check" },
  { value: "24h",  label: "Response Time",  icon: "bi-clock-fill" },
];

const TestimonialSection = () => {
  const allReviews = [...reviews, ...reviews];

  return (
    <section className="ts-section cs-section" style={{ backgroundColor: '#f8f9fa' }}>
      {/* Decorative shapes */}
      <div className="ts-bg-shape ts-shape-1"></div>
      <div className="ts-bg-shape ts-shape-2"></div>

      <div className="container position-relative">

        {/* Header */}
        <div className="row justify-content-center mb-2">
          <div className="col-lg-8 text-center">
            <div className="cs-badge d-flex justify-content-center">
           <Badge className="d-flex justify-content-center text-center mx-auto" text={"Customer Feedback"}></Badge>
           </div>
            <h2 className="cs-title ts-main-heading">
              Trusted by Hundreds of <br />
              <span className="ts-red">Property Owners</span>
            </h2>
            <div className="ts-header-line"></div>
          </div>
        </div>

        {/* Infinite Slider */}
        <div className="cs-content ts-slider-wrapper">
          <div className="ts-slider-track">
            {allReviews.map((item, index) => (
              <div className="ts-review-card" key={index}>
                <div className="ts-card-top">
                  <div className="ts-quote-icon">
                    <i className="bi bi-quote"></i>
                  </div>
                  <div className="ts-stars">
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                    <i className="bi bi-star-fill"></i>
                  </div>
                </div>

                <p className="ts-review-body">"{item.text}"</p>

                <div className="ts-card-footer">
                  <div>
                    <h5 className="ts-user-name">{item.name}</h5>
                    <span className="ts-user-meta">{item.service}</span>
                    <span className="ts-user-location">{item.location}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Stats Bar */}
        <div className="row g-0 ts-stats-row mt-5">
          {stats.map((stat, idx) => (
            <div className="col-6 col-md-3" key={idx}>
              <div className="ts-stat-box">
                <i className={`bi ${stat.icon} ts-stat-icon`}></i>
                <h3 className="ts-stat-num">{stat.value}</h3>
                <p className="ts-stat-text">{stat.label}</p>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TestimonialSection;